import * as React from 'react';

const Logo = (): JSX.Element => <img src="/images/logo-vertex-inc-header.svg" alt="Application Logo" />;

export default Logo;
